module.exports = __webpack_public_path__ + "img/couples-065.10b5cf8b.jpg";